<main class="container-cco form-fields-sub-module">
	@if (options.length === 0) {
		<section class="form-box">
			<div class="ff-row-form">
				<div class="ff-field-size-3 ff-box-field">
					@if (loaded) {
						<lbca-input-radio
							[require]="true"
							label="Pedido"
							[options]="requestList"
							(changeValue)="changeLabelValue($event)"
						></lbca-input-radio>
					}
				</div>
			</div>
			<button
				class="btn-primary btn-type-2 w-[5%] mt-[25px]"
				[disabled]="optionsSelected.length === 0"
				(click)="selectItems()"
			>
				Adicionar
			</button>
		</section>
	}

	@if (options.length > 0) {
		<section>
			<!-- button back -->
			<div class="btn-primary btn-type-3 cursor-pointer" (click)="back()">
				<div class="icon-box text-gray-200">
					<lbca-icon name="lucide:chevron-down" />
				</div>
			</div>
			<div class="box-item mt-[30px] flex flex-col justify-center">
				<div class="box-info flex justify-between p-[20px] mb-[50px] bg-gray-50 rounded-lg">
					<div class="flex">
						<lbca-icon
							[name]="'quantidade-light-white'"
							class="img-quantidade mr-[10px]"
						></lbca-icon>
						<div class="box-title flex flex-col text-gray-700 text-[8px]">
							<p class="text-xs">Quantidade</p>
							<p class="text-xs mt-[5px]">{{ options.length }}</p>
						</div>
					</div>
					<div class="flex">
						<lbca-icon
							[name]="'total-inicial-light-white'"
							class="img-total-inicial mr-[10px] light-white"
						></lbca-icon>
						<div class="box-title flex flex-col text-gray-700 text-[8px]">
							<p class="text-xs">Total</p>
							<p class="text-xs mt-[5px]">{{ calculateTotal() | currency: 'BRL' }}</p>
						</div>
					</div>
				</div>
				<lbca-table [table]="mountTable(options)"></lbca-table>
				<div class="flex flex-col mt-[20px] mb-[20px]">
					<div class="flex">
						<button (click)="toggleInputs()" class="btn-type-3 btn-primary ml-[7px]">
							<lbca-icon name="lucide:plus" size="small" class="text-gray-50" />
						</button>
						<span class="h-[32px] flex ml-[12px] mt-[4px] text-sm text-gray-700">
							Desmembramento
						</span>
					</div>
				</div>
				@if (showDismemberment) {
					<div class="box-input mt-[10px]">
						<div class="flex">
							<!-- select com as opções de desmembramento -->
							<lbca-select
								class="mr-[10px]"
								[label]="'Desmembramento'"
								[require]="false"
								[options]="dismemberOptions"
								(changeValue)="changeValue($event, 'type')"
								[value]="valueField.type"
							></lbca-select>
							<!-- input valor do desmembramento -->
							<lbca-input-text
								[label]="'Valor'"
								[tabeled]="false"
								[labeled]="true"
								[error]="errors ? errors : []"
								[require]="false"
								[maskInput]="'CURRENCY_BR'"
								(changeValue)="changeValue($event, 'value')"
								[value]="valueField.value"
							></lbca-input-text>
							<div class="flex cursor-pointer mt-[10px]">
								<button
									(click)="addField(options)"
									[disabled]="!valueField.type || !valueField.value"
									class="btn-primary btn-type-2 ml-[25px] load-action"
									type="button"
								>
									Adicionar
								</button>
							</div>
						</div>
					</div>
				}
				<!-- campos dos desmembramento adicionados -->
				@if (dismemberList.length > 0) {
					<div class="box-table mt-[20px] flex flex-wrap">
						@for (field of dismemberList; track field) {
							<div>
								<div class="flex items-center mr-[20px] mt-[30px] mb-[12px]">
									<lbca-input-text
										[labeled]="false"
										[componetHelperIconLeftStyle]="'quantidade-' + 'light-white'"
										[copyContent]="false"
										[label]="getLabel(field?.type, dismemberOptions)"
										[value]="setMask(maskcurrencyBr, field.value)"
									></lbca-input-text>
									<lbca-icon
										name="lucide:trash-2"
										(click)="removeItem(field.id, dismemberList)"
										class="icon-trash cursor-pointer btn-hover"
									></lbca-icon>
								</div>
							</div>
						}
					</div>
				}
			</div>
		</section>
	}

	@if (options.length > 0) {
		<div class="divider"></div>
	}

	@if (options.length > 0) {
		<section class="mt-5">
			<ng-container *ngTryFor="let field of fields">
				<div class="ff-row-form overflow-x-hidden">
					<ng-container *ngTryFor="let item of field">
						<ng-container
							*ngTemplateOutlet="fieldMultiplex; context: { dataField: item }"
						></ng-container>
					</ng-container>
					@if (field.length === 0) {
						<div class="h-[32px]"></div>
					}
				</div>
			</ng-container>
		</section>
	}
</main>

<ng-template let-field="dataField" #fieldMultiplex>
	@if (
		ccoForm.formControlStructure.fieldControl[field.entityKey]
			? ccoForm.formControlStructure.fieldControl[field.entityKey].visible
			: false
	) {
		<div [ngClass]="'ff-field-size-' + field.size" [class.ff-box-field]="!(field.size === 0)">
			@if (field.type === 'HIDDEN') {
				<lbca-input-hidden
					[label]="field.label"
					[defaultValue]="field.defaultValue"
				></lbca-input-hidden>
			}
			@if (field.type === 'TEXT') {
				<lbca-input-text
					[label]="field.label"
					[placeholder]="field.placeholder || ''"
					[error]="
						ccoForm.formControlStructure.fieldControl[field.entityKey]
							? ccoForm.formControlStructure.fieldControl[field.entityKey].error
							: []
					"
					[disabled]="
						field.disabled ||
						(field.childrenDependency &&
							ccoForm.formControlStructure.fieldControl[field.entityKey].disabled)
					"
					[require]="field.required"
					[maskInput]="field.mask"
					[fieldMetadata]="field"
					(setError)="subFormModuleInstance(field.entityKey, 'error', $event)"
					(validStatus)="subFormModuleInstance(field.entityKey, 'valid', $event)"
					(changeValue)="subFormModuleInstance(field.entityKey, 'value', $event)"
					[value]="
						data && data[field.entityKey]
							? data[field.entityKey]
							: field.defaultValue
								? field.defaultValue
								: ''
					"
					[helperText]="field.helperText"
					[rules]="field.rules"
				></lbca-input-text>
			}
			@if (field.type === 'PROCESS_NUMBER') {
				<lbca-input-process-number
					[label]="field.label"
					[error]="
						ccoForm.formControlStructure.fieldControl[field.entityKey]
							? ccoForm.formControlStructure.fieldControl[field.entityKey].error
							: []
					"
					[disabled]="
						field.disabled ||
						(field.childrenDependency &&
							ccoForm.formControlStructure.fieldControl[field.entityKey].disabled)
					"
					[require]="field.required"
					[maskInput]="field.mask"
					[fieldMetadata]="field"
					(setError)="subFormModuleInstance(field.entityKey, 'error', $event)"
					(validStatus)="subFormModuleInstance(field.entityKey, 'valid', $event)"
					(changeValue)="subFormModuleInstance(field.entityKey, 'value', $event)"
					[value]="
						data && data[field.entityKey]
							? data[field.entityKey]
							: field.defaultValue
								? field.defaultValue
								: ''
					"
					[helperText]="field.helperText"
				></lbca-input-process-number>
			}
			@if (field.type === 'INPUT_REF') {
				<legalboxplus-input-reference
					[cardData]="cardInfo"
					[label]="field.label"
					[field]="field"
					[value]="data ? data[field.entityKey] : ''"
				></legalboxplus-input-reference>
			}
			@if (field.type === 'TEXT-CONDENSED') {
				<lbca-input-text-condensed
					[label]="field.label"
					[error]="
						ccoForm.formControlStructure.fieldControl[field.entityKey]
							? ccoForm.formControlStructure.fieldControl[field.entityKey].error
							: []
					"
					[disabled]="
						field.disabled ||
						(field.childrenDependency &&
							ccoForm.formControlStructure.fieldControl[field.entityKey].disabled)
					"
					[require]="field.required"
					[maskInput]="field.mask"
					(setError)="subFormModuleInstance(field.entityKey, 'error', $event)"
					(validStatus)="subFormModuleInstance(field.entityKey, 'valid', $event)"
					(changeValue)="subFormModuleInstance(field.entityKey, 'value', $event)"
					[value]="data ? data[field.entityKey] : ''"
					[helperText]="field.helperText"
				></lbca-input-text-condensed>
			}
			@if (field.type === 'TEXTAREA') {
				<lbca-textarea
					[label]="field.label"
					[error]="
						ccoForm.formControlStructure.fieldControl[field.entityKey]
							? ccoForm.formControlStructure.fieldControl[field.entityKey].error
							: []
					"
					[disabled]="
						field.disabled ||
						(field.childrenDependency &&
							ccoForm.formControlStructure.fieldControl[field.entityKey].disabled)
					"
					[require]="field.required"
					(errorState)="subFormModuleInstance(field.entityKey, 'error', $event)"
					(validStatus)="subFormModuleInstance(field.entityKey, 'valid', $event)"
					(changeValue)="subFormModuleInstance(field.entityKey, 'value', $event)"
					[value]="data ? data[field.entityKey] : ''"
					[helperText]="field.helperText"
					[rules]="field.rules"
				></lbca-textarea>
			}
			@if (field.type === 'DATE_TIME') {
				<lbca-date-time-picker
					[value]="data ? data[field.entityKey] : ''"
					[labelDate]="field.labelDate"
					[labelTime]="field.labelTime"
					[disabled]="
						field.disabled ||
						(field.childrenDependency &&
							ccoForm.formControlStructure.fieldControl[field.entityKey].disabled)
					"
					[require]="field.required"
					[error]="
						ccoForm.formControlStructure.fieldControl[field.entityKey]
							? ccoForm.formControlStructure.fieldControl[field.entityKey].error
							: []
					"
					(setError)="subFormModuleInstance(field.entityKey, 'error', $event)"
					(validStatus)="subFormModuleInstance(field.entityKey, 'valid', $event)"
					(changeValue)="subFormModuleInstance(field.entityKey, 'value', $event)"
					[helperText]="field.helperText"
					[rules]="field.rules"
					[disabledDateRules]="field.disabledDateRules"
				></lbca-date-time-picker>
			}
			@if (field.type === 'CALENDAR') {
				<lbca-date-picker
					[label]="field.label"
					[disabled]="
						field.disabled ||
						(field.childrenDependency &&
							ccoForm.formControlStructure.fieldControl[field.entityKey].disabled)
					"
					[require]="field.required"
					[error]="
						ccoForm.formControlStructure.fieldControl[field.entityKey]
							? ccoForm.formControlStructure.fieldControl[field.entityKey].error
							: []
					"
					(setError)="subFormModuleInstance(field.entityKey, 'error', $event)"
					(validStatus)="subFormModuleInstance(field.entityKey, 'valid', $event)"
					(changeValue)="subFormModuleInstance(field.entityKey, 'value', $event)"
					[value]="data ? data[field.entityKey] : ''"
					[helperText]="field.helperText"
					[rules]="field.rules"
					[disabledDateRules]="
						ccoForm.formControlStructure.fieldControl[field.entityKey]?.disabledDateRules ||
						field.disabledDateRules
					"
				></lbca-date-picker>
			}
			@if (field.type === 'TIME') {
				<lbca-timepicker
					[label]="field.label"
					[disabled]="
						field.disabled ||
						(field.childrenDependency &&
							ccoForm.formControlStructure.fieldControl[field.entityKey].disabled)
					"
					[require]="field.required"
					[error]="
						ccoForm.formControlStructure.fieldControl[field.entityKey]
							? ccoForm.formControlStructure.fieldControl[field.entityKey].error
							: []
					"
					(errorState)="subFormModuleInstance(field.entityKey, 'error', $event)"
					(validStatus)="subFormModuleInstance(field.entityKey, 'valid', $event)"
					(changeValue)="subFormModuleInstance(field.entityKey, 'value', $event)"
					[value]="data ? data[field.entityKey] : ''"
					[helperText]="field.helperText"
				></lbca-timepicker>
			}
			@if (field.type === 'TREE_TABLE') {
				<lbca-tree-table
					[value]="data ? data[field.entityKey] : ''"
					[field]="field"
				></lbca-tree-table>
			}
			@if (
				field.auxEntity &&
				(field.auxEntity.entityUrl !== null || field.auxEntity.listOptions) &&
				field.type !== 'TREE_TABLE'
			) {
				<lbca-entity-fields
					[isOpen]="true"
					[forceType]="field.type === 'LIST_REF' ? 'LIST_REF' : null"
					[label]="field.label"
					[error]="
						ccoForm.formControlStructure.fieldControl[field.entityKey]
							? ccoForm.formControlStructure.fieldControl[field.entityKey].error
							: []
					"
					[field]="field"
					[cardData]="cardInfo"
					[dataFather]="field.childrenDependency ? field.childrenDependency.father : null"
					[disabled]="
						field.disabled ||
						(field.childrenDependency &&
							ccoForm.formControlStructure.fieldControl[field.entityKey].disabled)
					"
					[readOnly]="field.readOnly"
					[require]="field.required"
					[flowId]="cardInfo['flowId']"
					(setError)="subFormModuleInstance(field.entityKey, 'error', $event)"
					(errorApi)="erroApi($event)"
					[value]="data ? data[field.entityKey] : ''"
					[defaultValue]="field.defaultValue"
					(changeValue)="subFormModuleInstance(field.entityKey, 'value', $event)"
					(startValue)="subFormModuleInstance(field.entityKey, 'startValue', $event)"
					(validStatus)="subFormModuleInstance(field.entityKey, 'valid', $event)"
					[dynamicFormService]="ccoForm"
					[initialized]="initialized"
					[helperText]="field.helperText"
				></lbca-entity-fields>
			}
			@if (field.type === 'SELECT_TREE_CONDENSED') {
				<lbca-select-tree-condensed
					[field]="field"
					[label]="field.label"
					[cardData]="cardInfo"
					[value]="data ? data[field.entityKey] : ''"
				></lbca-select-tree-condensed>
			}
			@if (field.type === 'GRIDBOX_UNIQUE') {
				<lbca-gridbox-unique
					[field]="field"
					[cardData]="cardInfo"
					[configuration]="field.configuration"
					[label]="field.label"
					[labeled]="true"
					[error]="
						ccoForm.formControlStructure.fieldControl[field.entityKey]
							? ccoForm.formControlStructure.fieldControl[field.entityKey].error
							: []
					"
					[disabled]="
						field.disabled ||
						(field.childrenDependency &&
							ccoForm.formControlStructure.fieldControl[field.entityKey].disabled)
					"
					[require]="field.required"
					(setError)="subFormModuleInstance(field.entityKey, 'error', $event)"
					(validState)="subFormModuleInstance(field.entityKey, 'valid', $event)"
					(changeValue)="subFormModuleInstance(field.entityKey, 'value', $event)"
					[value]="data ? data[field.entityKey] : ''"
					[helperText]="field.helperText"
				></lbca-gridbox-unique>
			}
			@if (field.type === 'TABLE_LIST') {
				<lbca-table-list
					[cardData]="cardInfo"
					[disabled]="
						field.disabled ||
						(field.childrenDependency &&
							ccoForm.formControlStructure.fieldControl[field.entityKey].disabled)
					"
					[field]="field"
					[dataAttr]="dataAttr"
					[error]="
						ccoForm.formControlStructure.fieldControl[field.entityKey]
							? ccoForm.formControlStructure.fieldControl[field.entityKey].error
							: []
					"
					[value]="data ? data[field.entityKey] : ''"
				></lbca-table-list>
			}
			@if (field.type === 'MESSAGE') {
				<lbca-message-field [label]="field.label" [color]="field.color"></lbca-message-field>
			}
			@if (field.type === 'FILE_UPLOAD') {
				<lbca-sub-module-file-upload
					[idEntity]="field.entityKey"
					[value]="data ? data[field.entityKey] : ''"
					[label]="field.label"
					[dataAttr]="dataAttr"
					[cardData]="cardInfo"
					[flowId]="cardInfo['flowId']"
					[error]="
						ccoForm.formControlStructure.fieldControl[field.entityKey]
							? ccoForm.formControlStructure.fieldControl[field.entityKey].error
							: []
					"
					[disabled]="
						field.disabled ||
						(field.childrenDependency &&
							ccoForm.formControlStructure.fieldControl[field.entityKey].disabled)
					"
					[properties]="field"
					(saveValue)="saveUpload($event)"
					(errorApi)="erroApi($event)"
					(validateCallback)="setValidationCallback($event, field.entityKey)"
				></lbca-sub-module-file-upload>
			}
			@if (field.type === 'FILE_FROM_PROCESS') {
				<lbca-file-from-process
					[label]="field.label"
					[buttonLabel]="field.buttonLabel"
					[value]="data ? data[field.entityKey] : ''"
					[flowId]="cardInfo['flowId']"
					[context]="field.context"
					[cardData]="cardInfo"
					[properties]="field"
					(saveValue)="saveUpload($event)"
					(validateCallback)="setValidationCallback($event, field.entityKey)"
				>
					>
				</lbca-file-from-process>
			}
			@if (
				ccoForm.formControlStructure.fieldControl[field.entityKey].visible &&
				ccoForm.formControlStructure.fieldControl[field.entityKey].locked &&
				!ccoForm.formControlStructure.fieldControl[field.entityKey].unlocked
			) {
				<ng-container class="mt-[5px] pt-[5px]">
					<div class="dyc-dependency-module">
						<div class="ff-row-form mb-[15px]">
							<p class="text-font text-xs">{{ field.label }}</p>
						</div>
						<div class="dyc-msg-container">
							<div class="flex flex-col">
								<div class="dyc-text-msg">
									{{ ccoForm.formControlStructure.fieldControl[field.entityKey].msg }}
								</div>
							</div>
							<div class="emojis-shackle icon-box ml-[16px]"></div>
						</div>
					</div>
				</ng-container>
			}
		</div>
	}
</ng-template>
